import { makeObservable, observable, runInAction, action, makeAutoObservable } from 'mobx';
import { RateServices } from '../services/rateServices';
import i18n from 'i18next';
import { toast } from "react-toastify";
import { makePersistable, stopPersisting } from 'mobx-persist-store';


export default class RateStore {    

    
  rootStore;
  rates = [];
    rate = {};
    config = {
        sort: [],
        filter: [],
        size: {}
    };

  constructor(rootStore) {
      this.rootStore = rootStore;

      makeObservable(this, {
          config: observable,
          setConfig: action,


          rates: observable,
          rate: observable,
          getAll: action,          
          reset: action,
          save: action,
          remove: action,  
          upload:action
      });
      makePersistable(this, { name: 'rateStore', properties: ['config'], storage: window.localStorage });

    }       

    upload = async (file) => {
        try {
            const data = await RateServices.upload(file);
            runInAction(() => { toast.success(`${i18n.t("wasUpdated", { entity: i18n.t("rate") })}`); });
        } catch (error) {
            runInAction(() => { /*this.vatSettings = {};*/ })
        }
    }

    remove = async (id) => {
        try {
            const data = await RateServices.delete(id);
            runInAction(() => {toast.success(`${i18n.t("wasDeleted", { entity: i18n.t("rate") })}`);});
        } catch (error) {
            runInAction(() => {/*toast.error(i18n.t("errorOcurred"));*/});
        }
    }

    save = async (entity, onSuccess) => {
        if (entity.id) {
            try {
                const data = await RateServices.update(entity.id, entity);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    this.reset();
                    toast.success(`${i18n.t("wasUpdated", { entity: i18n.t("rate") })}`);
                });
            } catch (error) {}
        } else {
            try {
                const data = await RateServices.create(entity);
                runInAction(() => {
                    if (onSuccess) { onSuccess() };
                    toast.success(`${i18n.t("wasCreated", { entity: i18n.t("rate") })}`);
                    this.reset();                    
                });
            } catch (error) {}
        }
    };

    reset = () => {        
        runInAction(() => this.rate = {});
    }
    
    
    setConfig = (prop, c) => { this.config[prop] = c; }

    getAllWithOptions = async (options/*page, filter, sort*/) => {
        try {
            const data = await RateServices.getAllWithOptions(options/*{ page: page, filter: filter, sort: sort }*/);
            runInAction(() => {
                this.rates = data;
            })
        }
        catch (error) {
            runInAction(() => {
                this.rates = [];
            });
        }
    }

    getAll = async (page, filter, sort) => {
        try {
            const data = await RateServices.getAll({ page: page, filter: filter, sort: sort });
            runInAction(() => { this.rates = data;})
        }
        catch (error) {
            runInAction(() => { this.rates = [];});
        }
    }    

    getById = async (id) => {
        try {
            const data = await RateServices.getById(id);
            runInAction(() => { this.rate = data;});
        } catch (error) {
            runInAction(() => { this.rate = {};})
        }
    };

    
}